module.exports = __webpack_public_path__ + "assets/images/05Box.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/05Box.png
// module id = 1261
// module chunks = 1